const prefix = 'DimPurchaseOrder';

export enum DimPurchaseOrderField {
  ID = `${prefix}.id`,
  PRIMARY_SOURCE_REFERENCE = `${prefix}.primarySourceReference`,
  SUPPLIER_ID = `${prefix}.supplierId`,
  COUNT = `${prefix}.count`,
  CREATED_AT = `${prefix}.createdAt`,
  TOTAL_VALUE_NORMALIZED = `${prefix}.totalValueNormalized`,
  TOTAL_VALUE = `${prefix}.totalValue`,
}
